/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import {
    object, func, string,
} from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from '@material-ui/core';
import useSalesforcePersonalizedContentQuery from '../../../../../../helpers/Personalization/useSalesforcePersonalizedContentQuery';
import { getBrandName } from '../../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import GenericSkeleton from '../../../../GraphqlSkeletonComponents/GenericSkeleton';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import useClickStreamCustomEventsTracking from '../../../../../../helpers/Personalization/useClickstreamCustomEventsTracking';
import { getCurrentPageType } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Selectors';
import GiftFinderEds from './GiftFinderEds';

const GiftFinderEdsAbTestContainer = ({
    data, handleSubmitEds, userSubmittedZip, handleChange, onSubmitCheck, zip, validatedZip, setSelectedOccasion, buttonStyle,
}) => {
    const brandName = useSelector(getBrandName);
    const dispatch = useDispatch();
    const pageType = useSelector(getCurrentPageType);
    const giftFinderWidth = data?.has_full_width ? '100%' : '1012px';

    const { data: deCoupleGiftFinderData, loading, variables } = useSalesforcePersonalizedContentQuery({
        queryName: 'decoupleGiftFinder',
        interactionName: `${brandName} - Get Campaign - Gift Finder Decouple`,
        featureFlag: true, // ff is higher up in parent component this fires if desktop only
        optInHoldoutParticipation: false,
        resolveIdentity: false,
    });

    // Control or Test(variant) value from Decouple Gift Finder Sales Force Test
    const deCoupleGiftFinderUserGroup = deCoupleGiftFinderData?.contentSF?.campaign?.campaignResponses?.[0]?.experienceName;

    let giftFinderRender = true;
    if (typeof deCoupleGiftFinderUserGroup !== 'undefined' && deCoupleGiftFinderUserGroup) {
        const isMatch = ((userGroupRaw, abGroupRaw) => {
            const normalize = (str) => str?.trim()?.toLowerCase()?.replace('controlfake', 'control');
            return normalize(userGroupRaw) === normalize(abGroupRaw);
        })(deCoupleGiftFinderUserGroup, data?.a_b_testing?.variant);
        giftFinderRender = isMatch;
    }
    useClickStreamCustomEventsTracking({
        salesforceResponse: deCoupleGiftFinderData?.contentSF,
        isFireImpression: true,
        page: { type: pageType },
    });

    useEffect(() => {
        if (typeof deCoupleGiftFinderUserGroup !== 'undefined' && !window.wuDecoupleGiftFinderEventFired && deCoupleGiftFinderUserGroup) {
            // GA tracking
            const eventParam = {
                eventCategory: 'Experiment',
                eventAction: 'Gift Finder Decouple',
                eventLabel: deCoupleGiftFinderUserGroup,
                feature_detail: deCoupleGiftFinderUserGroup,
                feature_element: 'Gift Finder Decouple',
                feature_category: 'Experiment',
            };
            dispatch(trackEvent(eventParam));
            window.wuDeCoupleGiftFinderEventFired = true;
        }
        return () => {
            window.wuDeCoupleGiftFinderEventFired = false;
        };
    }, [deCoupleGiftFinderUserGroup]);

    if (variables?.skip || loading) {
        return (
            <GenericSkeleton height="112px" width={giftFinderWidth} />
        );
    }

    if (giftFinderRender) {
        return (
            <GiftFinderEds
                data={data}
                handleSubmitEds={handleSubmitEds}
                userSubmittedZip={userSubmittedZip}
                handleChange={handleChange}
                onSubmitCheck={onSubmitCheck}
                zip={zip}
                validatedZip={validatedZip}
                setSelectedOccasion={setSelectedOccasion}
                buttonStyle={buttonStyle}
            />
        );
    }
    return null;
};

GiftFinderEdsAbTestContainer.propTypes = {
    buttonStyle: object,
    data: object.isRequired,
    onSubmitCheck: func.isRequired,
    handleChange: func.isRequired,
    handleSubmitEds: func.isRequired,
    validatedZip: string.isRequired,
    setSelectedOccasion: func.isRequired,
    userSubmittedZip: string.isRequired,
    zip: string,
};

GiftFinderEdsAbTestContainer.defaultProps = {
    zip: '',
    buttonStyle: {},
};

export default GiftFinderEdsAbTestContainer;
